import script from "./RoleSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./RoleSelect.vue?vue&type=script&setup=true&lang=js"

import "./RoleSelect.vue?vue&type=style&index=0&id=6fdd1a89&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fdd1a89"]])

export default __exports__